import Phaser from "phaser";
import { helper } from "../cGameObjects/helper";
import { Layout } from "../cGameObjects/modules/Layout";
import { cScene } from "../cScene";
import { cGame } from "../cGame";
import { speechBubble } from "./speechBubble";
import { getStr } from "../utils/simpleLocalisation";



export class infoBubble extends Phaser.GameObjects.Container {

  private layout:Layout = new Layout(this,{} as any)
  private bubbleData: any;
  private parts:any
  private arrowPos: any;

  constructor(sc:cScene, data:any, cb: Function){
    super(sc,0,0);

    this.bubbleData = data;
    this.layout.setOfs(data.ofs)

    this.parts = {}


    if (this.bubbleData.dir){
      this.parts.arrow = new Phaser.GameObjects.Sprite(sc as any,0,0,'infoBubble',`arrow_b.png`);    
      this.parts.arrow.setOrigin(0.5,0.5)
      this.add(this.parts.arrow);  
    }

    this.parts.top = new Phaser.GameObjects.Sprite(sc as any,0,0,'infoBubble',`info_back_top.png`);    
    this.parts.top.setOrigin(0,0)
    this.add(this.parts.top);

    this.parts.mid = new Phaser.GameObjects.Sprite(sc as any,0,19,'infoBubble',`info_back_mid.png`);   
    this.parts.mid.setOrigin(0,0)
    this.add(this.parts.mid);

    this.parts.but = new Phaser.GameObjects.Sprite(sc as any,0,19,'infoBubble',`info_back_but.png`);    
    this.parts.but.setOrigin(0,0)
    this.add(this.parts.but);

    if (this.bubbleData.dir){      
      this.parts.arrow_f = new Phaser.GameObjects.Sprite(sc as any,0,0,'infoBubble',`arrow_f.png`);    
      this.parts.arrow_f.setOrigin(0.5,0.5)
      this.add(this.parts.arrow_f);
    }

    this.parts.txt = helper.createTextfield(sc, this.bubbleData.value,`infobubble`)
    this.parts.txt.setOrigin(0,0)
    this.parts.txt.setPosition(24,20)
    this.add(this.parts.txt)


    this.parts.close = new Phaser.GameObjects.Sprite(sc as any,0,0,'infoBubble','close.png');
    this.parts.close.scale = 1.2
    this.add(this.parts.close)
  
    this.parts.mid.displayHeight = this.parts.txt.height
    this.parts.but.y = this.parts.txt.height + this.parts.mid.y

    var wi = 412;
    var hi = this.parts.but.y + 20;
    var stalk = Number(this.bubbleData.stalk) || 50;

    // place the arrow
    switch (this.bubbleData.dir){
      case 'left':
        this.arrowPos = {angle:90, x:0, y: hi / 100 * stalk, vx:1, vy:0 }
        this.parts.close.x = wi - 30
        this.parts.close.y = hi / 2
        break;
      case 'right':
        this.arrowPos = {angle:-90, x:wi, y: hi / 100 * stalk, vx:1, vy:0 }
        this.parts.close.x = wi - 30
        this.parts.close.y = hi / 2
        break;
      case 'up':
        this.arrowPos = {angle:-180, x: wi / 100 * stalk, y: 0, vx:0, vy:1 }
        this.parts.close.x = wi - 30
        this.parts.close.y = hi -30
        break;
      case 'down':
        this.arrowPos = {angle:0, x: wi / 100 * stalk, y: hi-10, vx:0, vy:1 }
        this.parts.close.x = wi - 30
        this.parts.close.y = 30
        break;
      default:        
        this.arrowPos = {angle:0, x: wi / 100 * stalk, y: hi-10, vx:0, vy:1 }
        this.parts.close.x = wi - 30
        this.parts.close.y = 30
    }

    if (this.parts.arrow){
      this.parts.arrow.y = this.parts.arrow_f.y = this.arrowPos.y;
      this.parts.arrow.x = this.parts.arrow_f.x = this.arrowPos.x;
      this.parts.arrow.angle = this.parts.arrow_f.angle = this.arrowPos.angle;  
    }


    Object.keys(this.parts).forEach( (k)=>{
      this.parts[k].x -= (wi/2)
      this.parts[k].y -= (hi/2)
      if (this.bubbleData.value === '' && k.indexOf('arrow') === -1){
        this.parts[k].visible = false;
      }
    });

    this.arrowPos.x = this.parts.arrow ? this.parts.arrow.x : 0;
    this.arrowPos.y = this.parts.arrow ? this.parts.arrow.y : 0;
    this.scale = 0.2
    this.alpha = 0;
    this.scene.tweens.add({
      targets:this,
      ease: 'Back.easeOut',
      duration:500,
      scale:1,
      alpha:1
    });

    var cc = 0;
    sc.events.on('render',()=>{
      cc++;
      if (cc % 3 === 0) this.update(cc);
    });

    (this.scene as cScene).snd('sound_popup')


    if (sc.debugMode){
      this.setupDragging(sc);
    }else{
      this.parts.mid.setInteractive({ useHandCursor: true });
      this.parts.mid.on('pointerup',()=>{
        this.close();
        cb();
      });      
    }


    console.log('INFO SPEAK',cGame.current.state.get('voiceover',null),this.bubbleData.voice)
    if (cGame.current.state.get('voiceover',null) === 'on' && this.bubbleData.voice){
      var s = getStr(String(this.bubbleData.value).trim());
      console.log('OKO',s)            
      speechBubble.voiceOver.speak(s, this.bubbleData.voice)
    }


  }

  update(ck: number) {
    var si:number = 6;
    var mpx: number = 3;
    var sx = Math.sin( Math.PI / 180 * (ck*mpx) ) * (si * this.arrowPos.vx);
    var sy = Math.cos( Math.PI / 180 * (ck*mpx) ) * (si * this.arrowPos.vy);    
    if (this.parts.arrow){
      this.parts.arrow.x = this.parts.arrow_f.x = this.arrowPos.x + sx;
      this.parts.arrow.y = this.parts.arrow_f.y = this.arrowPos.y + sy;  
    }
  }

  
  close() {
    var $this = this;
    speechBubble.voiceOver.stop()
    this.scene.tweens.add({
      targets:this,
      ease: 'Back.easeIn',
      duration:300,
      scale:0.2,
      alpha:0,
      onComplete:()=>{
        $this.getAll().forEach( el=>el.destroy() )
        $this.destroy();
      }
    });
  }

  public set isClosed(v:any){
    this.close();
  }

  setupDragging(sc:any) {
    if (! (window as any).adminLink ) return

    var $this = this
    //var $savedPos = [this.lay.x, this.lay.y];

    var stalk:Phaser.GameObjects.Sprite = new Phaser.GameObjects.Sprite(sc,0,0,'icons','debug');
    stalk.x = this.x;
    stalk.y = this.y;
    this.scene.add.existing(stalk);

    setTimeout( ()=> {
      stalk.setInteractive({useHandCursor:true});
      sc.input.setDraggable( stalk )
      sc.input.enable(stalk);

      sc.input.on('drag',(p:any,gameObj:any,x:number,y:number)=>{
        if (gameObj !== stalk) return
        $this.x = stalk.x = x;
        $this.y = stalk.y = y;
      });

      sc.input.on('dragend',(p:any, gameObj:any)=>{
        if (gameObj !== stalk) return
        (window as any).adminLink('updateBubblePosition', {
          id: $this.bubbleData._id,
          x : Math.round($this.x),
          y : Math.round($this.y)
        })
      })

    },500)


  }

}